import CreatePayrollReceipt from './views/Create.vue'
import Validate from './views/ValidateIdentity.vue'
import RequestShareAccess from './views/RequestShareAccess.vue'
import CreateCertifiedLetters from './views/CreateLettersCertificates.vue'

export const PayrollReceipts = [
  {
    path: '/payroll-receipt',
    name: 'PayrollReceipt',
    component: CreatePayrollReceipt,
    meta: {
      auth: true,
      layout: 'home',
      hideWhenFlag: 'new_payment_slips'
    }
  },
  {
    path: '/payroll-receipt/validate',
    name: 'Validate',
    component: Validate,
    meta: {
      auth: false,
      layout: 'public'
    }
  },
  {
    path: '/payroll-receipt/share',
    name: 'RequestShareAccess',
    component: RequestShareAccess,
    meta: {
      auth: false,
      layout: 'public'
    }
  },
  {
    path: '/certified-letters',
    name: 'CreateCertifiedLetters',
    component: CreateCertifiedLetters,
    meta: {
      auth: true,
      layout: 'home'
    }
  }
]
